// Vida en Orden — fuente de verdad ÚNICA para el estado de una tarea (JS).
// Espejo idéntico de /app/backend/status.py (task_status) — mismos umbrales,
// mismo enum, mismos labels y emojis. Cualquier surface JS (Web) DEBE usar
// esta función — nunca comparar `due_date < today` inline.
//
// Estados:
//   completada   ← task.completed === true (gana siempre)
//   sin_fecha    ← no hay due_date parseable
//   vencida      ← due_date < hoy AR
//   hoy          ← due_date === hoy AR
//   proxima      ← due_date > hoy AR
//
// Una tarea con due_date en el pasado y completed=false permanece VENCIDA
// (pendiente) — Vida en Orden NUNCA la marca automáticamente completada.

const { todayInAR } = require('./isOverdue');

const LABELS = {
  vencida: 'VENCIDA',
  hoy: 'HOY',
  proxima: 'PRÓXIMA',
  completada: 'COMPLETADA',
  sin_fecha: 'SIN FECHA',
};

const EMOJIS = {
  vencida: '🔴',
  hoy: '🟠',
  proxima: '🟡',
  completada: '✅',
  sin_fecha: '⚪',
};

const _PRIORITY = {
  vencida: 0,
  hoy: 1,
  proxima: 2,
  completada: 3,
  sin_fecha: 4,
};

function taskStatus(task, now = new Date()) {
  if (!task || typeof task !== 'object') return 'sin_fecha';
  if (task.completed) return 'completada';
  const due = task.due_date;
  if (!due || typeof due !== 'string') return 'sin_fecha';
  const dueDay = due.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dueDay)) return 'sin_fecha';
  const today = todayInAR(now);
  if (dueDay < today) return 'vencida';
  if (dueDay === today) return 'hoy';
  return 'proxima';
}

function taskStatusLabel(status) { return LABELS[status] || ''; }
function taskStatusEmoji(status) { return EMOJIS[status] || ''; }
function taskStatusPriority(status) { return _PRIORITY[status] ?? 99; }

module.exports = { taskStatus, taskStatusLabel, taskStatusEmoji, taskStatusPriority };
